import { Box, Button, ButtonProps, Text, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SaveAndSyncContent } from './SaveAndSyncContent';
import {
  useTexasDrawer,
  TexasDrawer,
} from '@texas/components/shared/drawer/TexasDrawer';
import { TexasDrawerCloseButton } from '@texas/components/shared/drawer/TexasDrawerCloseButton';
import { TexasDrawerHeader } from '@texas/components/shared/drawer/TexasDrawerHeader';
import { ModalState } from '@texas/hooks/useChakraOutsideClick';
import { TexasDrawerContent } from '@texas/components/shared/drawer/TexasDrawerContent';

interface SaveAndSyncProps {
  variantId: number;
  articleId: number;
  syncedVariantId?: number;
  isMain: boolean;
  isProductDevelopment: boolean;
  isArticleArchived: boolean;
  buttonProps?: ButtonProps;
}

export function SaveAndSync(props: SaveAndSyncProps) {
  const drawer = useTexasDrawer(ModalState.Closed, true);

  const { t } = useTranslation();

  if (props.isProductDevelopment) return null;

  if (!props.isMain)
    return (
      <Text
        color="gray.300"
        fontFamily="fonts.body"
        fontStyle="italic"
        fontSize={14}
      >
        {t('variant.notMain')}
      </Text>
    );

  return (
    <Box>
      <TexasDrawer modal={drawer} ref={drawer.ref}>
        <TexasDrawerCloseButton setModalState={drawer.setModalState} />
        <TexasDrawerContent>
          <TexasDrawerHeader title={t('variant.sync.saveAndSync')} />

          <SaveAndSyncContent
            drawerState={drawer.modalState}
            configuration={{
              variantId: props.variantId,
              allBranches: false,
              articleId: props.articleId,
              syncedVariantId: props.syncedVariantId,
            }}
            onSyncSuccess={() => drawer.setModalState(ModalState.Closed)}
          />
        </TexasDrawerContent>
      </TexasDrawer>
      <Tooltip
        isDisabled={!props.isArticleArchived}
        label={t('variant.sync.archivedArticle')}
        placement="top"
      >
        <Box>
          <Button
            ml={2}
            variant="texas"
            onClick={() => {
              drawer.setModalState(ModalState.Open);
            }}
            {...props.buttonProps}
            isDisabled={props.isArticleArchived}
          >
            {t('variant.sync.saveAndSync')}
          </Button>
        </Box>
      </Tooltip>
    </Box>
  );
}
